import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
  SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
} from '@oneaudi/unified-web-common';
import {
  SYS_BORDER_RADIUS_MD,
  SYS_COLOR_CANVAS_100_DARK,
  SYS_COLOR_CANVAS_200_DARK,
  SYS_GRADIENT_ELEVATION_LEVEL1_FILL_DARK,
  SYS_SPACE_FIXED_200,
} from '@oneaudi/unified-web-alpha-common';
import { CustomTheme } from '../@types/theme';
/*
  Define  color tokens.
  (preferably use "only" tokens from @oneaudi/unified-web-common)
*/

export const xsBreakPoint = parseInt(SYS_BREAKPOINT_XS, 10);
export const smBreakPoint = parseInt(SYS_BREAKPOINT_SM, 10);
export const mdBreakPoint = parseInt(SYS_BREAKPOINT_MD, 10);
export const lgBreakPoint = parseInt(SYS_BREAKPOINT_LG, 10);
export const xlBreakPoint = parseInt(SYS_BREAKPOINT_XL, 10);
export const xxlBreakPoint = parseInt(SYS_BREAKPOINT_2_XL, 10);

const colorsLight = {
  globalColorElevation: SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
  baseColor: '#FFFFFF',
};

const colorsDark = {
  globalColorElevation: SYS_GRADIENT_ELEVATION_LEVEL1_FILL_DARK,
  sysColorCanvas100: SYS_COLOR_CANVAS_100_DARK,
  sysColorCanvas200: SYS_COLOR_CANVAS_200_DARK,
  sysGradientElevationLevel1Fill: SYS_GRADIENT_ELEVATION_LEVEL1_FILL_DARK,
  baseColor: '#000000',
};

const breakpoints = {
  xs: parseInt(SYS_BREAKPOINT_XS, 10),
  sm: parseInt(SYS_BREAKPOINT_SM, 10),
  md: parseInt(SYS_BREAKPOINT_MD, 10),
  lg: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};

const spacing = {
  sysSpaceFixed200: SYS_SPACE_FIXED_200,
};

export const lightTheme: CustomTheme = {
  name: 'light',
  colors: colorsLight,
  breakpoints,
  borderRadius: {
    md: parseInt(SYS_BORDER_RADIUS_MD, 10),
  },
  spacing,
};

export const darkTheme: CustomTheme = {
  name: 'dark',
  colors: colorsDark,
  breakpoints,
  borderRadius: {
    md: parseInt(SYS_BORDER_RADIUS_MD, 10),
  },
  spacing,
};
